@let profile = user();
@let name = displayName() | titlecase;

@if (isCompact()) {
  <button
    type="button"
    class="header-profile-avatar-trigger"
    [mlMenuTrigger]="profileMenu"
    mlMenuTriggerPlacement="bottom-end"
    [attr.aria-label]="'header.profileAria' | mlTranslate"
  >
    <ml-avatar
      [image]="profile?.avatar"
      [fallback]="profile | mlInitials"
      [ariaLabel]="'header.profileAria' | mlTranslate"
      rounded
    />
  </button>
} @else {
  <div class="header-tablet-profile">
    <ml-avatar
      [image]="profile?.avatar"
      [fallback]="profile | mlInitials"
      [ariaLabel]="'header.profileAria' | mlTranslate"
      rounded
    />
    <button
      mlButton
      intent="neutral"
      variant="outline"
      size="sm"
      suffixIconName="chevronDown"
      suffixIconSize="sm"
      userClass="header-profile-button gap-1 data-hover:bg-transparent"
      [mlMenuTrigger]="profileMenu"
      mlMenuTriggerPlacement="bottom-end"
      [mlMenuTriggerOffset]="menuOffset"
      [attr.aria-label]="'header.profileAria' | mlTranslate"
    >
      <span class="truncate">{{ name }}</span>
    </button>
  </div>
}

<ml-menu
  #profileMenu
  panelClass="header-profile-menu-panel w-72"
  [items]="profileItems"
  [sheetOnMobile]="false"
  (itemSelect)="onSelect($event)"
>
  <div class="flex items-center gap-2.5 px-4 py-3">
    <ml-avatar
      [image]="profile?.avatar"
      [fallback]="profile | mlInitials"
      [ariaLabel]="'header.profileAria' | mlTranslate"
      rounded
    />
    <div class="min-w-0 flex-auto">
      <p class="text-body-small truncate font-semibold text-neutral-900">
        {{ name }}
      </p>
      @if (profile?.email; as email) {
        <p class="text-caption truncate text-neutral-300">{{ email }}</p>
      }
    </div>
  </div>
  <div class="h-px w-full bg-neutral-50" role="separator"></div>
</ml-menu>
